import { z } from "zod";

// TES-482 (appdesign 08/09, Ö-29) — a patient's completed-pass ledger, kept on
// the server so "nästa pass i ordningen" survives a reinstall and agrees
// across devices. Deliberately coarse: one row per pass with a completion
// COUNT and the latest completion time. The in-pass step state (which
// exercise, which round) stays on the device — it is a live session, not a
// record, and syncing it would only create phantom "half-done" passes.
export const workoutProgressItemSchema = z.object({
  passKey: z.string().min(1).max(200),
  completedCount: z.number().int().min(0),
  lastCompletedAt: z.string().datetime().nullable(),
});
export type WorkoutProgressItem = z.infer<typeof workoutProgressItemSchema>;

export const workoutProgressResponseSchema = z.object({
  items: z.array(workoutProgressItemSchema),
});
export type WorkoutProgressResponse = z.infer<
  typeof workoutProgressResponseSchema
>;

// PUT body. The server never lowers either field: an offline device that
// completed a pass twice and a fresh device that says "once" merge to twice
// (Ö-29: union/max, never last-writer-wins).
export const workoutProgressUpsertSchema = z.object({
  completedCount: z.number().int().min(0).max(100_000),
  lastCompletedAt: z.string().datetime().nullable(),
});
export type WorkoutProgressUpsert = z.infer<typeof workoutProgressUpsertSchema>;
